import { isBefore, subDays } from 'date-fns';

export function getHasBeenFourteenDays(timestamp: number) {
	return !(timestamp && isBefore(subDays(new Date(), 14), timestamp));
}
